import React from 'react';
import PropTypes from 'prop-types';

/**
 * BreadcrumbItem Atom
 * Renders an individual part of the breadcrumb navigation.
 * Supports links (<a>), buttons (<button>), and plain text/elements.
 */
const BreadcrumbItem = ({ item, isCollapsed, onClick, closeMenuOnClick }) => {
   if (!item) {
      return null;
   }

   // Handle the collapsed placeholder item
   if (isCollapsed) {
      return <span className="responsive-breadcrumb__separator">...</span>;
   }

   const handleClick = (event) => {
      if (item.onClick) {
         item.onClick(event);
      }

      if (closeMenuOnClick) {
         onClick?.();
      }
   };

   // Extract the node/label from the item
   // The item shape is normalized in ResponsiveBreadcrumb
   const node = item.node;

   if (item.href) {
      return (
         <a
            href={item.href}
            onClick={handleClick}
            target={item.target}
            rel={item.rel}
            className="responsive-breadcrumb__link"
         >
            {node}
         </a>
      );
   }

   if (item.onClick || item.href === undefined) {
      return (
         <button
            type="button"
            className="responsive-breadcrumb__link-btn"
            onClick={handleClick}
         >
            {node}
         </button>
      );
   }

   return <span className="responsive-breadcrumb__text">{node}</span>;
};

BreadcrumbItem.propTypes = {
   item: PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      node: PropTypes.any,
      href: PropTypes.string,
      onClick: PropTypes.func,
      target: PropTypes.string,
      rel: PropTypes.string,
   }).isRequired,
   isCollapsed: PropTypes.bool,
   onClick: PropTypes.func, // Used for closing the menu
   closeMenuOnClick: PropTypes.bool,
};

export default BreadcrumbItem;
